import "react-native-gesture-handler";

import React from "react";
import { useFonts } from "expo-font";
import {
  Raleway_200ExtraLight,
  Raleway_700Bold,
} from "@expo-google-fonts/raleway";
import { Quicksand_300Light } from "@expo-google-fonts/quicksand";
import { NavigationContainer } from "@react-navigation/native";
import { Text } from "react-native";
import { MenuProvider } from "react-native-popup-menu";

import HomeStackNavigator from "./src/navigator/Navigation";

export default function App() {
  const [fontsLoaded] = useFonts({
    Raleway_200ExtraLight,
    Raleway_700Bold,
    Quicksand_300Light,
  });
  if (!fontsLoaded) {
    return <Text>Loading...</Text>;
  }

  return (
    <MenuProvider>
      <NavigationContainer>
        <HomeStackNavigator />
      </NavigationContainer>
    </MenuProvider>
  );
}
